import {
  IconDashboard,
  IconBook,
  IconMessage,
  IconShare,
  IconBriefcase,
  IconMessageChatbot,
  IconFileAnalytics,
  IconTrophy,
  IconExternalLink,
  IconKey,
  IconUsers,
  IconTargetArrow
} from '@tabler/icons-react';

const icons = {
  IconDashboard,
  IconBook,
  IconMessage,
  IconShare,
  IconBriefcase,
  IconMessageChatbot,
  IconFileAnalytics,
  IconTrophy,
  IconExternalLink,
  IconKey,
  IconUsers,
  IconTargetArrow
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  icon: icons.IconDashboard,
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'oms',
      title: 'OMS',
      type: 'item',
      url: 'http://164.52.194.132/#!/login',
      icon: icons.IconExternalLink,
      external: true,
      target: true,
      breadcrumbs: false,
      chip: {
        label: 'External',
        color: 'warning',
        variant: 'outlined',
        size: 'small'
      }
    },
    {
      id: 'knowledge-center',
      title: 'Knowledge Center',
      type: 'item',
      url: '/knowledge-center',
      icon: icons.IconBook,
      breadcrumbs: true
    },
    {
      id: 'mattermost',
      title: 'Mattermost',
      type: 'item',
      url: '/mattermost',
      icon: icons.IconMessage,
      breadcrumbs: true
    },
    {
      id: 'social-media',
      title: 'Social Media',
      type: 'item',
      url: '/social',
      icon: icons.IconShare,
      breadcrumbs: true
    },
    {
      id: 'portfolio-review',
      title: 'Portfolio Review Context',
      type: 'item',
      url: '/portfolio',
      icon: icons.IconFileAnalytics,
      breadcrumbs: true
    },
    {
      id: 'outreach-engine',
      title: 'Outreach Engine',
      type: 'item',
      url: '/outreach',
      icon: icons.IconTargetArrow,
      breadcrumbs: true
    },
    {
      id: 'client-registry',
      title: 'Client Registry',
      type: 'item',
      url: '/clients',
      icon: icons.IconUsers,
      breadcrumbs: true
    },
    {
      id: 'client-passwords',
      title: 'Client PDF Passwords',
      type: 'item',
      url: '/client-passwords',
      icon: icons.IconKey,
      breadcrumbs: true
    },
    {
      id: 'mf-ranking',
      title: 'MF Ranking',
      type: 'item',
      url: '/mf-ranking',
      icon: icons.IconTrophy,
      breadcrumbs: true
    },
    {
      id: 'chat',
      title: 'Chat',
      type: 'item',
      url: '/chat',
      icon: icons.IconMessageChatbot,
      breadcrumbs: true
    },
    {
      id: 'internal-kit-corner',
      title: 'Internal Kit Corner',
      type: 'item',
      url: '/internal-kit-corner',
      icon: icons.IconBriefcase,
      breadcrumbs: true
    }
  ]
};

export default dashboard;
